import _isEmpty from 'lodash.isempty';
import { withRouter } from 'react-router-dom';
import compare from 'react-fast-compare';
import { connect } from 'react-redux';
import { constants, DataGridConnector, actionTypes } from '@vooban/datagrid';
import { updateUserPreferences } from '../../../actions/userPreferencesActions';

// Each PATCH sends the whole presets map, so they must reach the server in order or an older map wins.
let pendingPresetSave = Promise.resolve();

export const setDataGridPreset =
  ({ pathname, pathKey, payload: { action, preset, id } }) =>
  async (dispatch, getState) => {
    const { presetSelectedIdsStoreKey, presetsStoreKey } = constants;
    const { [presetSelectedIdsStoreKey]: prevSelectedPresetIds, [presetsStoreKey]: prevPresets } = getState().dataGrid;
    dispatch({
      type: actionTypes.SET_PRESETS,
      payload: { pathname, pathKey, action, preset, id },
    });

    const { [presetSelectedIdsStoreKey]: selectedPresetIds, [presetsStoreKey]: presets } = getState().dataGrid;
    const dataToUpdate = {};

    if (!compare(prevPresets, presets)) {
      dataToUpdate[presetsStoreKey] = presets;
    }

    // The selection is an index into the presets list, so the list goes with it to keep both in sync on the server.
    if (!compare(prevSelectedPresetIds, selectedPresetIds)) {
      dataToUpdate[presetSelectedIdsStoreKey] = selectedPresetIds;
      dataToUpdate[presetsStoreKey] = presets;
    }

    if (!_isEmpty(dataToUpdate)) {
      // A failed save must not block the ones queued after it.
      pendingPresetSave = pendingPresetSave.catch(() => undefined).then(() => dispatch(updateUserPreferences(dataToUpdate)));
      await pendingPresetSave;
    }
  };

const mapDispatchToProps = {
  ...DataGridConnector.mapDispatchToProps,
  setDataGridPreset,
};
export default withRouter(connect(DataGridConnector.mapStateToProps, mapDispatchToProps)(DataGridConnector));
